

































































































import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import { decode as entityDecode } from 'he'

import ScorecardProfileImage from '@/components/Scorecard/ScorecardProfileImage.vue'
import Typography from "@/components/Rain/Typography/Typography.vue"
import { ScorecardEntity } from '@/entities/scorecard'
import { getOrdinal } from '@/utils/number'

import IconUp from "@/assets/img/Icons/leaderboard-up.svg"
import IconDown from "@/assets/img/Icons/leaderboard-down.svg"
import IconMedalGold from '@/assets/img/Icons/medal-gold.svg'
import IconMedalSilver from '@/assets/img/Icons/medal-silver.svg'
import IconMedalBronze from '@/assets/img/Icons/medal-bronze.svg'

@Component<ScorecardHeader>({
    components: {ScorecardProfileImage, Typography},
    filters: {
        getOrdinal,
        entityDecode,
    }
})
export default class ScorecardHeader extends Vue {
    iconUp = IconUp
    iconDown = IconDown

    @Prop(Object) public scorecard !: ScorecardEntity
    @Prop({type: Boolean, required: false}) public touring ?: boolean
    @Prop({type: Boolean, required: false}) public isTeamMemberView ?: boolean
    @Prop(String) public ratingLabel !: string
    @Prop(String) public locationText !: string

    public get rankValues() {
      return this.scorecard.rankValues.filter(rank => rank > 0 ).slice(0, 3)
    }

    get medalIcon() {
        switch (this.scorecard.status) {
            case 'gold':
                return IconMedalGold
            case 'silver':
                return IconMedalSilver
            case 'bronze':
                return IconMedalBronze
            default:
                return IconMedalBronze
        }
    }

    onClickRank() {
        if (this.scorecard.status && this.scorecard.status !== 'gold') {
            return
        }
        this.$emit('rank')
    }
}
